"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var material_ui_1 = require("material-ui");
exports.default = (function (props) {
    return react_1.default.createElement(material_ui_1.RaisedButton, __assign({}, props));
});
//# sourceMappingURL=Button.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/Button.js
// module id = 15
// module chunks = 0